import {
    http,
    Header,
    ContentType,
    qs,
    GetFormData,
    StatusCode,
    Global,
    Method
} from './api-util';

export async function currentLiveRecord({liveId}) {
    return http({
        method: Method.GET,
        url: Global.BASE_URL + '/api/live_record/current',
        params: {
            liveId
        }
    }).then(res => res.data)
}